import React, { Component } from "react";
import Input from "../Input/Input";
import Button from "../button/button";
import { bindActionCreators } from "redux";
import { handleSearch, openOrCloseSearchMobile } from "../../js/actions/sales";
import connect from "react-redux/es/connect/connect";

class SearchMobile extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpen: false
		};

		this.searchParameter = "";
	}

	openOrClose = () => {
		this.props.openOrCloseSearchMobile(!this.props.isOpened);
	};

	handleChange = event => {
		this.searchParameter = event;
	};

	handleSearch = () => {
		this.props.handleSearch(this.searchParameter);
		this.props.openOrCloseSearchMobile(false);
	};

	render() {
		let dataAction = this.props.hasOwnProperty("data-action")
			? this.props["data-action"]
			: "search-mobile-offers";
		return (
			<div className="modal-fade-in">
				<Button className="btn-green-md-icon" onClick={this.openOrClose}>
					<i className="icon-search" />
				</Button>

				{this.props.isOpened && (
					<div className="search-mobile" data-action={dataAction}>
						<div className="content">
							<h5>Busca</h5>
							<div className="input-container">
								<Input
									placeholder="Localizador ou Transação"
									onChange={e => this.handleChange(e)}
								/>
								<Button className="btn-green-md-s" onClick={e => this.handleSearch()}>
									Buscar
								</Button>
							</div>
						</div>
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	isOpened: state.mySales.searchWebIsOpen
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			handleSearch,
			openOrCloseSearchMobile
		},
		dispatch
	);
export default connect(mapStateToProps, mapDispatchToProps)(SearchMobile);
